import { render, staticRenderFns } from "./SubmissionCard.vue?vue&type=template&id=730e9bf6&scoped=true&"
import script from "./SubmissionCard.vue?vue&type=script&lang=js&"
export * from "./SubmissionCard.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionCard.vue?vue&type=style&index=0&id=730e9bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730e9bf6",
  null
  
)

export default component.exports